import React, { Component } from 'react'
import { observer } from 'mobx-react'
import withStyles, { ThemeProvider } from 'react-jss'
import classNames from 'classnames'

import { COURSE_LESSONS_LIST_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import { CoverWidget } from '@elo-kit/components/elo-ui/cover-widget/CoverWidget'

import lessonsListStyles from './lessonsListStyles'

const defaultProps = {
  mobileMenuActive: false,
}

const LessonsListContainer = withStyles(lessonsListStyles)((props) => {
  const { classes, children, title } = props
  return (
    <div className={classNames(COURSE_LESSONS_LIST_CLASS_NAMES.containerClassName, classes.lessonsListSection)}>
      <div className={classes.title}>{title || I18n.t('react.cabinet.course_program')}</div>
      <div className={classes.lessonsContainer}>{children}</div>
    </div>
  )
})

const LessonWidget = withStyles(lessonsListStyles)((props) => {
  const { classes, lesson, btnAction, showActionBtn } = props
  const noCover = classNames(classes.noCoverContainer, 'far fa-image')
  const btnText = (lesson.lessonSettings || {}).overviewBtnText || I18n.t('react.common.learn_more')

  return (
    <div className={classNames(COURSE_LESSONS_LIST_CLASS_NAMES.itemContainerClassName, classes.lessonWidgetContainer)}>
      <CoverWidget
        noImageClasses={noCover}
        unresponsive
        img
        cover={{
          file: {
            s640: lesson.lessonSettings.cover,
            s100: lesson.lessonSettings.cover,
          },
        }}
      />
      <div className={classes.lessonDetails}>
        <div className={classes.lessonTitle}>{lesson.name}</div>
        {showActionBtn && (
          <div
            className={classes.button}
            onClick={() => {
              btnAction(lesson.children)
              window.scrollTo(0, 0)
            }}
          >
            {btnText}
          </div>
        )}
      </div>
    </div>
  )
})

@observer
class LessonsList extends Component {
  openLessonFirstLessonOfCategory = (lessons) => {
    const { detectFirstLessonIdDeep, selectLesson } = this.props.courseViewsStore

    const lessonId = detectFirstLessonIdDeep(lessons)
    if (lessonId) {
      selectLesson(lessonId, false, true)
      this.props.courseViewsStore.showOverviewPage = false
    }
  }

  render() {
    const { courseViewsStore } = this.props
    const { lessons, courseThemeData, detectFirstLessonIdDeep } = courseViewsStore
    const lessonsForOverview = lessons.filter((item) => item.overview && item.active)

    return (
      <ThemeProvider theme={courseThemeData.prefs}>
        <LessonsListContainer title={courseThemeData.prefs.courseOverview.overviewTitle}>
          {lessonsForOverview.map(
            (item) =>
              !!item.children.length && (
                <LessonWidget
                  lesson={item}
                  key={item.id}
                  btnAction={this.openLessonFirstLessonOfCategory}
                  showActionBtn={!!detectFirstLessonIdDeep(item.children)}
                />
              )
          )}
        </LessonsListContainer>
      </ThemeProvider>
    )
  }
}

LessonsList.defaultProps = defaultProps

export default LessonsList
